<!-- Sidebar -->
<app-sidebar></app-sidebar>
<div>
  <app-header></app-header>
  <!-- Page Content -->
  <div id="content">
    <div style="padding-right: 15px;">
      <h4>Página não encontrada</h4>
    </div>
    <br /><br />
  </div>
</div>